import { create } from "zustand";
import getDataForHome from "../api/api";
import { assignedOrder } from "../api/api";
import { rawEngagement } from "../api/api";

const useStore = create((set) => ({
  data: [],
  isLoading: true,
  assignedOrders: [],
  rawEngagements: [],
  assignedLoading: false,
  rawLoading: false,
  isError: false,
  fetchHomeData: async () => {
    set({ isLoading: true });
    getDataForHome()
      .then((response) => {
        set({ data: response.data });
      })
      .catch((error) => {
        set({ isError: true, data: [] });
      })
      .finally(() => {
        set({ isLoading: false });
      });
  },
  fetchRevenue: async (sd, ed) => {
    set({ assignedLoading: true });
    try {
      const response = await assignedOrder(sd, ed);
      set({ assignedOrders: response.data, assignedLoading: false });
    } catch (error) {
      set({ isError: true, assignedLoading: false });
    }
  },
  fetchEngageStatus: async (sd, ed) => {
    set({ rawLoading: true });
    try {
      const response = await rawEngagement(sd, ed);
      set({ rawEngagements: response.data, rawLoading: false });
    } catch (error) {
      set({ isError: true, rawLoading: false });
    }
  },
}));

export default useStore;
